export default __webpack_public_path__ + "static/media/enugu_gouni.b0b345f2.gif";